import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as ElementUI from 'element-ui'
import store from './store'
import * as animated from 'animate.css'
import "@/assets/text/text.css";
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import VueWechatTitle from 'vue-wechat-title' 


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(animated)
Vue.use(VueWechatTitle)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
